import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ContentExpansion from "../../../../../components/ContentExpansion";
import { SpacerContainer } from "../../../../../components/styledComponents/SpacerContainer";
import { useGetTraggliedDatenQuery } from "../../../../../services/API/titanApi";
import {
  selectFrontendZustand,
  setKnickenNachDINEN1993Details,
} from "../../../../../store/slices/frontendZustandSlice";
import { selectBerechneKnickenDinEN1993 } from "../../../../../store/slices/innereSlice";
import { selectTragglied } from "../../../../../store/slices/traggliedSlice";
import Nachweis from "./Nachweis/Nachweis";
import ParameterTragglied from "./ParameterTragglied/ParameterTragglied";

function DinEN1993() {
  const { t } = useTranslation("translation");

  // #region Redux Store Variables
  const tragglied = useSelector(selectTragglied);
  const { knickenNachDINEN1993Details } = useSelector(selectFrontendZustand);
  const { data: traggliedDaten } = useGetTraggliedDatenQuery(tragglied.title);
  const berechneteWerte = useSelector(selectBerechneKnickenDinEN1993(traggliedDaten));
  // #endregion

  return (
    <SpacerContainer>
      <div className="row">
        <ContentExpansion
          expand={knickenNachDINEN1993Details}
          reducer={setKnickenNachDINEN1993Details}
        />
      </div>

      {knickenNachDINEN1993Details == false && (
        <div className="box">
          <div className="row">
            <h1>{t("inner.buckling.crossSectionParametersMicropile")}</h1>
          </div>
        </div>
      )}

      <ParameterTragglied
        expand={knickenNachDINEN1993Details}
        querschnitt={traggliedDaten?.querschnitt}
        innendurchmesser={traggliedDaten?.knicken?.innendurchmesser}
        aussendurchmesser={berechneteWerte?.berechneteKnickenWerte?.aussendurchmesser}
        dehnsteifigkeit={traggliedDaten?.knicken?.dehnsteifigkeit}
        e_modul={berechneteWerte?.berechneteKnickenWerte?.elastizitaetsmodul}
        traegheitsmoment={berechneteWerte?.berechneteKnickenWerte?.traegheitsmoment}
        biegesteifigkeit={traggliedDaten?.knicken?.biegesteifigkeit}
        charakteristischeFestigkeit={
          berechneteWerte?.berechneteKnickenWerte?.charakteristischeFestigkeit
        }
      />
      <Nachweis
        expand={knickenNachDINEN1993Details}
        kritischeKnicklaenge={berechneteWerte?.berechneteKnickenWerte?.kritischeKnicklaenge}
        traegheitsradius={berechneteWerte?.berechneteKnickenWerte?.traegheitsradius}
        bezugsschlankheitsgrad={berechneteWerte?.berechneteKnickenWerte?.bezugsschlankheitsgrad}
        bezogenerSchlankheitsgrad={
          berechneteWerte?.berechneteKnickenWerte?.bezogenerSchlankheitsgrad
        }
        abminderungsfaktor={berechneteWerte?.abminderungsfaktor}
        delta={berechneteWerte?.phi_calc}
        biegeknickbeanspruchbarkeit={berechneteWerte?.biegeknickbeanspruchbarkeit}
      />
    </SpacerContainer>
  );
}

export default DinEN1993;
